export default __webpack_public_path__ + "static/media/PLW.fecbe609.svg";